/**
 * The shape of a guide.
 *
 * Guides answer what people in each market actually search for — how to
 * budget a quincena, what a statement's closing date is, how interest-free
 * instalments are charged — in the same structured blocks the legal pages
 * use, so the table of contents and the anchors are generated and the two
 * languages keep the same sections. A guide teaches first; how TwoCoins helps
 * is its last section, never its premise.
 */
import type { ReactNode } from 'react';

import type { LegalSection } from '../legal/types';

export type GuideId =
  'budget-by-paycheck' | 'statement-and-due-dates' | 'interest-free-instalments';

export const GUIDE_IDS: GuideId[] = [
  'budget-by-paycheck',
  'statement-and-due-dates',
  'interest-free-instalments',
];

export interface Guide {
  id: GuideId;
  title: string;
  /** One or two sentences under the title, and on the guides' index. */
  intro: ReactNode;
  /** The same, as plain text: for the index card and the article's structured data. */
  summary: string;
  /** ISO date it was first published. */
  published: string;
  /** ISO date it was last reviewed. */
  updated: string;
  sections: LegalSection[];
}
